import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';
import * as $api from '@/api';
import { ChatStateDispatchContext } from '@/components/Chat.State/context';
import type { ChatAction } from '@/types/chat.actions';
import {
  ActiveChatSessionContext,
  ChatSessionFiltersContext,
} from '../context';
import { useScrollToBottomOfMessages } from './useScrollMessageList';

type MutationVars = {
  identifier: string;
  parentQueryIdentifier: string;
  query: string;
  action: ChatAction | null;
};

export const useSubmitQueryMutation = () => {

  const chat = useContext(ActiveChatSessionContext);
  const filters = useContext(ChatSessionFiltersContext);
  const dispatch = useContext(ChatStateDispatchContext);
  const scrollToBottom = useScrollToBottomOfMessages();

  const mutation = useMutation({
    mutationKey: ['chat:message:submit'],
    mutationFn: (vars: MutationVars) => {
      return $api.submitChatQuery({
        action: vars.action,
        chatIdentifier: chat.identifier,
        identifier: vars.identifier,
        parentQueryIdentifier: vars.parentQueryIdentifier,
        query: vars.query,
        context: chat.context,
        filters,
      });
    },
    onMutate: ({ action, identifier, parentQueryIdentifier, query }) => {
      dispatch({
        type: 'query-submitted',
        payload: {
          chatIdentifier: chat.identifier,
          identifier,
          parentQueryIdentifier,
          value: query,
          hideUserMessage: !!action,
        },
      });
      scrollToBottom();
    }, onError: (error: AxiosError<AxiosResponse>, vars) => {
      if (error.response?.status === 504 || error.status === 504) {
        return;
      }

      const traceId = error.response?.headers['x-sentry-trace-id'] as string;
      dispatch({
        type: 'query-errored',
        payload: {
          langfuseTraceUrl: null,
          queryIdentifier: vars.identifier,
          traceId,
        },
      });
      scrollToBottom();
    }, onSuccess: () => {
      // dispatch({
      //   type: 'query-response-available',
      //   payload: {
      //     chatInstance: res.chatInstance,
      //     query: res.query,
      //   },
      // });
      // scrollToBottom();
    },
  });

  return mutation;
};